import { Button } from '@welbe/design-system';
import { Drawer, PageWrapper } from '@welbe/web-design-system';
import { ReactComponent as CandidatesSvg } from 'App/assets/img/candidatos-icon-black.svg';
import { ReactComponent as Download } from 'App/assets/img/download.svg';
import { IntroTutorial } from 'App/Components/IntroTutorial/IntroTutorial';
import { ModalCandidateCsv } from 'App/Components/ModalCandidateCsv/ModalCandidateCsv';
import { ModalUploadCsv } from 'App/Components/ModalUploadCsv/ModalUploadCsv';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import useCandidates from './Candidates.hooks';
import { ButtonsWrapper, Wrapper } from './Candidates.styles';
import { AddCandidateButton } from './components/AddCandidateButton/AddCandidateButton';
import { CallToActionCandidate } from './components/CallToActionCandidate/CallToActionCandidate';
import { CallToActionExams } from './components/CallToActionExams/CallToActionExams';
import { CandidatesButtons } from './components/CandidatesButtons';
import { Content } from './components/Content/Content';
import { ExamsProfileModal } from './components/ExamsProfileModal/ExamsProfileModal';
import { ManageProfileButton } from './components/ManageProfileButton/ManageProfileButton';
import { ModalApproveCandidate } from './components/ModalApproveCandidate/ModalApproveCandidate';
import { ModalDisabledFeat } from './components/ModalDisabledFeat/ModalDisabledFeat';
import { ModalRejectCandidate } from './components/ModalRejectCandidate/ModalRejectCandidate';
import { tutorialCandidateSteps } from './constants/tutorialCandidateSteps';

const customStyle = {
	drawer: {
		boxShadow: '0px -5px 19px -7px rgba(0,0,0,0.3)',
	},
};

export const Candidates = (): JSX.Element => {
	const {
		isDisabledFeatModalVisible,
		setDisabledFeatModalVisible,
		selectedCandidates,
		isOpenDrawer,
		isOpenModalUpload,
		isLoadingCsv,
		showModalApproveCandidate,
		showModalRejectCandidate,
		hasJustPendentAtRHStatus,
		hasJustPendentAtDoctorStatus,
		isBroker,
		width,
		isProfileModalVisible,
		showTutorial,
		showCallToActionCandidateModal,
		showCallToActionExamsModal,
		handleCSV,
		reloadTable,
		setReloadTable,
		setIsOpenDrawer,
		handleToggleProfileModal,
		handleEditAppointment,
		handleNewCandidate,
		setSelectedCandidates,
		handleCloseModalUpload,
		handleShowModalRejectCandidate,
		handleCloseModalRejectCandidate,
		handleShowModalApproveCandidate,
		handleCloseModalApproveCandidate,
		handleFinishCandidateTutorial,
		handleCloseShowCallToActionCandidateModal,
		handleCloseShowCallToActionExamsModal,
		handleDownloadCsv,
		confirmModal,
		handleSelectCandidates,
	} = useCandidates();

	useAnalyticsOpenScreen({
		context: 'candidate',
		trackName: 'Open Candiate List',
		analyticProps: { isBroker },
	});

	return (
		<PageWrapper
			icon={<CandidatesSvg />}
			title="Candidatos"
			slotHeader={
				<ButtonsWrapper>
					<Button
						loading={isLoadingCsv}
						onClick={handleDownloadCsv}
						width="150px"
						variant="outline"
						id="downloadCandidateCsv"
					>
						<ButtonsWrapper>
							Descargar CSV <Download />
						</ButtonsWrapper>
					</Button>
					<ManageProfileButton onClick={handleToggleProfileModal} />
					<AddCandidateButton
						onUploadCandidates={handleCSV}
						onCreateCandidate={handleNewCandidate}
					/>
				</ButtonsWrapper>
			}
		>
			<Wrapper>
				<Content
					onSelect={handleSelectCandidates}
					selectedCandidates={selectedCandidates}
					onUpdateTable={reloadTable}
				/>
			</Wrapper>
			<Drawer
				id="drawer-candidates"
				customStyle={customStyle.drawer}
				position="bottom"
				onClose={() => setIsOpenDrawer(false)}
				open={isOpenDrawer}
				width={width}
				height="150px"
				useBackDropContainer={false}
				left="unset"
			>
				<CandidatesButtons
					handleShowModalRejectCandidate={handleShowModalRejectCandidate}
					handleShowModalApproveCandidate={handleShowModalApproveCandidate}
					onEditAppointment={handleEditAppointment}
					amountCandidates={selectedCandidates.length}
					hasJustPendentAtRHStatus={hasJustPendentAtRHStatus}
					hasJustPendentAtDoctorStatus={hasJustPendentAtDoctorStatus}
				/>
			</Drawer>
			{showModalApproveCandidate && (
				<ModalApproveCandidate
					selectedCandidates={selectedCandidates}
					setSelectedCandidates={setSelectedCandidates}
					setReloadTable={setReloadTable}
					handleClose={handleCloseModalApproveCandidate}
				/>
			)}
			{showModalRejectCandidate && (
				<ModalRejectCandidate
					selectedCandidates={selectedCandidates}
					setSelectedCandidates={setSelectedCandidates}
					setReloadTable={setReloadTable}
					handleClose={handleCloseModalRejectCandidate}
				/>
			)}
			{isOpenModalUpload && (
				<ModalUploadCsv
					origin="candidates"
					onClose={handleCloseModalUpload}
					isOpen={isOpenModalUpload}
				/>
			)}
			{isProfileModalVisible && (
				<ExamsProfileModal onClose={handleToggleProfileModal} mode="view" />
			)}
			{showTutorial && (
				<IntroTutorial
					context="candidate"
					height="650px"
					items={tutorialCandidateSteps}
					onFinish={handleFinishCandidateTutorial}
				/>
			)}
			{showCallToActionCandidateModal && (
				<CallToActionCandidate
					onFinish={handleCloseShowCallToActionCandidateModal}
				/>
			)}

			{showCallToActionExamsModal && (
				<CallToActionExams onFinish={handleCloseShowCallToActionExamsModal} />
			)}

			{isDisabledFeatModalVisible && (
				<ModalDisabledFeat onClose={() => setDisabledFeatModalVisible(false)} />
			)}

			<ModalCandidateCsv
				visible={confirmModal.show}
				onClose={confirmModal.onClose}
				imageUrl={confirmModal.icon}
				message={confirmModal.message}
				height="285px"
			/>
		</PageWrapper>
	);
};
